export const CELL_ACTIVE = "cell-active";
export const CELL_DIMMED = "cell-dimmed";
export const CELL_DEFAULT = "cell-default";

export const CELL_NAME = "name";
export const CELL_ACTION = "action";
export const CELL_SKU = "sku";
export const CELL_MANUFACTURER = "manufacturer";
export const CELL_PRICE = "price";
export const CELL_STOCK = "stock";
export const CELL_TOTAL = "total_price";
export const CELL_SELECT = "select";
